import { search } from "../../BaseRepositoryComponents";

const path =
  process.env.REACT_APP_URL_API_ERP + process.env.REACT_APP_PATH_API_COMPONENTS;
const pathEstoque = path + "/v1/localestoque";
const pathGrupo = path + "/v1/produtogrupo";
const pathFabricante = path + "/v1/fabricante";
const pathSubgrupo = path + "/v1/produtosubgrupo";

export function findEstoque(empresa_cnpj) {
  return search(`${pathEstoque}?empresa_cnpj=${empresa_cnpj}`);
}

export function findFabricante(empresa_cnpj) {
  return search(`${pathFabricante}?empresa_cnpj=${empresa_cnpj}`);
}

export function findGrupo(empresa_cnpj) {
  return search(`${pathGrupo}?empresa_cnpj=${empresa_cnpj}`);
}

export function findSubGrupo(empresa_cnpj, grupoid) {
  return search(
    `${pathSubgrupo}?empresa_cnpj=${empresa_cnpj}&grupoid=${grupoid}`
  );
}
